import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Price from './Price.js'
import BG from '../BG.js'

const ProductItem = ({images, slug, url, title, price, stock, currencyCode = 'AUD'}) => {
  function renderImage () {
    const image = images[0]
    if (!image) return false
    return (
      <BG image={image} />
    )
  }

  price = parseFloat(price)
  stock = parseInt(stock, 10)

  return (
    <Link to={`/gallery/${slug}/`} className='ProductItem' data-url={url}>
      <div className='image is-rounded'>
        {renderImage()}
      </div>
      <div className='flex'>
        <h5
          className='title'
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {(stock && price)
          ? (
            <h6 className='price' data-currency={currencyCode}>
              <Price price={price} code={currencyCode} />
            </h6>
          )
          : (
            price > 0 &&
            <h6 className='price sold'>
              Sold
            </h6>
          )
        }
      </div>
    </Link>
  )
}

ProductItem.propTypes = {
  images: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
  url: PropTypes.string,
  title: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  currencyCode: PropTypes.string
}

export default ProductItem



// WEBPACK FOOTER //
// ./src/Shop/ProductItem.js